import { App } from '@openedx/frontend-base';
import { addScript, addSlot } from './utils';import { WidgetOperationTypes } from '@openedx/frontend-base';

const customApp: App = {
  appId: 'custom',
};
addSlot(customApp, 
    {
      slotId: 'org.openedx.frontend.layout.header_discussions.v1',
      op: WidgetOperationTypes.REMOVE,
      relatedId: 'defaultContent',
    });
addSlot(customApp, 
    {
      slotId: 'org.openedx.frontend.slot.header.discussions.v1',
      op: WidgetOperationTypes.REMOVE,
      relatedId: 'defaultContent',
    });
addSlot(customApp, 
    {
      slotId: 'org.openedx.frontend.layout.footer.v1',
      op: WidgetOperationTypes.REMOVE,
      relatedId: 'indigo_footer',
    });
addSlot(customApp, 
    {
      slotId: 'org.openedx.frontend.layout.footer.v1',
      op: WidgetOperationTypes.REMOVE,
      relatedId: 'custom_footer',
    });

export default customApp;